(function (angular) {
    'use strict';

    angular
        .module('app.privacy-policy')
        .config([
            '$stateProvider', 
            '$urlRouterProvider', 
            privacyPolicyRoutes
        ]);

    function privacyPolicyRoutes($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('app.privacy-policy', {
                url: '/privacy-policy',
                templateUrl: '/app/site/privacy-policy/privacy-policy.template.html',
                controller: 'app.privacy-policy.controller'
            });
    }
    
})(angular);
